module.exports = __webpack_public_path__ + "img/105ne.eae0761a.svg";